import "../prospect/addadvice.css";
import React, { useEffect, useState } from "react";
import {
  Button,
  Menu,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";
import { manualAdviceTabsPath, getDate, getToday } from "../utils/varialbles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import http from "../services/httpService";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import toast from "react-hot-toast";
import MenuItem from "@mui/material/MenuItem";
import { CancelOutlined } from "@mui/icons-material";
import { DataSheetGrid, textColumn, keyColumn } from "react-datasheet-grid";
import "react-datasheet-grid/dist/style.css";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { InvestmentPlan } from "../pdfreact/InvestmentPlan";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { convertToHTML } from "draft-convert";
import DOMPurify from "dompurify";

function Addadvice() {
  const [editorAbovetable, seteditorAbovetable] = useState(() =>
    EditorState.createEmpty()
  );

  const [editorBelowtable, seteditorBelowtable] = useState(() =>
    EditorState.createEmpty()
  );

  const [convertedContentAboveTable, setconvertedContentAboveTable] =
    useState(null);
  const [convertedContentBelowTable, setConvertedContentBelowTable] =
    useState(null);

  const _contentState = ContentState.createFromText("Enter Text Here");
  const raw = convertToRaw(_contentState); // RawDraftContentState JSON
  const [contentState, setContentState] = useState(raw);

  useEffect(() => {
    let html = convertToHTML(editorAbovetable.getCurrentContent());
    setconvertedContentAboveTable(html);
  }, [editorAbovetable]);

  useEffect(() => {
    let html = convertToHTML(editorBelowtable.getCurrentContent());
    setConvertedContentBelowTable(html);
  }, [editorBelowtable]);

  function createMarkup(html) {
    return {
      __html: DOMPurify.sanitize(html),
    };
  }

  const history = useHistory();

  const gotoAdviceRequest = () => {
    history.push({
      pathname: manualAdviceTabsPath,
    });
  };

  const formattedDate = getToday();

  const [pdfName, setpdfName] = useState("");
  const [pdfcontent, setpdfcontent] = useState({
    date: formattedDate,
  });
  //3console.log(pdfName, "pdfName");

  const [fieldData, setFieldData] = useState([
    {
      label: "Mobile Number",
      important: true,
      id: 0,
      type: "text",
      name: "mobile",
    },
    {
      label: "Total Advised Amount",
      important: true,
      id: 1,
      type: "text",
      name: "totaladvisedamnt",
    },
    {
      label: "Choose Country",
      important: true,
      id: 2,
      type: "select",
      name: "country",
    },
    {
      label: "Asset Name",
      important: true,
      id: 3,
      type: "autocomplete",
      name: "assetname",
    },
    {
      label: "Asset Type",
      important: true,
      id: 4,
      type: "text",
      name: "assettype",
    },
    {
      label: "ISIN Number",
      important: true,
      id: 5,
      type: "text",
      name: "isinnum",
    },
    {
      label: "Amount",
      important: true,
      id: 6,
      type: "text",
      name: "Amount",
    },
  ]);

  const [data, setDta] = useState({
    statuscode: "",
    assetname: "",
    assettype: "",
    isinnum: "",
    id: "",
    country: "",
    amount: "",
    stockname: "",
    totaladvisedamnt: "",
  });

  // console.log(data.assetname, "assetname");

  const [getCntryData, setCntryData] = useState([]);
  const [oldArrar, setOldArray] = useState([]);
  // console.log(oldArrar);
  const [sumData, setSumData] = useState([]);
  const total = sumData.reduce((a, b) => a + b, 0);
  const [Verifybtn, setVerifybtn] = useState(true);

  const { statuscode } = data;

  const [previewRows, setpreviewRows] = useState([
    { active: true, firstName: "Elon", lastName: "Musk" },
    { active: false, firstName: "Jeff", lastName: "Bezos" },
  ]);

  const columns = [
    {
      ...keyColumn("stockname", textColumn), //checkboxColumn
      title: "Asset Name",
      disabled: true,
    },
    {
      ...keyColumn("assettype", textColumn),
      title: "Asset Type",
      disabled: true,
    },
    {
      ...keyColumn("ISINCode", textColumn),
      title: "ISIN Code",
      disabled: true,
    },
    {
      ...keyColumn("amount", textColumn),
      title: "Amount",
      disabled: true,
    },
  ];

  const [customerName, setcustomerName] = useState("");

  const handleChange = (e) => {
    setDta({ ...data, [e.target.name]: e.target.value });
    // console.log(document.getElementById('mobile').value="", "zxtykcvserezfgjlxdcfbhjksxcvbnm,xcvbnxdcfvbhnjfgbjm");
  };

  const handleChangeCompany = (e, value) => {
    // console.log(value, "cfvgbh");
    setDta({
      ...data,
      assetname: value.Investment_Name,
      assettype: value.Asset_Class,
      isinnum: value.ISINCode,
    });
  };

  const handlePdfContent = (e, para) => {
    setpdfcontent((prevState) => ({
      ...prevState,
      [para]: e.target.value,
    }));
  };

  const [disabled, setDisabled] = useState(true);
  const [disabled3, setDisabled3] = useState(false); //Disable Verify Feild & Button
  const [invlimit, setInvLimit] = useState("");

  // console.log(data["mobile"].length);

  const verifyNumber = () => {
    if (data.mobile != undefined && data.mobile != "") {
      http
        .get(`/validationrequest?mobile=${data.mobile}`)
        .then((res) => {
          console.log(res.data.remaining_limit, "res");
          if (res.data.statusCode === 0) {
            setDta({ ...data, statuscode: res.data.statusCode });
            setInvLimit(res.data.remaining_limit);
            setDisabled(false);
            setDisabled3(true);
            setCntryData(res.data.Data);
            setVerifybtn(false);
            setcustomerName(res.data.name); //Name to display
            setpdfName(res.data.name); //Name for PDF
          } else if (res.data.statusCode === 1) {
            toast(res.data.error);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toast.error("Enter Valid Mobile Number");
    }
  };

  // Style customerName to fit
  // const stylecustname =
  //   customerName.charAt(0).toUpperCase() + customerName.slice(1);

  useEffect(() => {}, [getCntryData, statuscode]);

  const sendDetails = {
    mobile: data["mobile"],
    amount: data["totaladvisedamnt"],
    country: data["country"],
  };

  // console.log(sendDetails);

  const [assetNames, setAssetNames] = useState([]);
  const [allAssetNames, setallassetNames] = useState([]);
  // console.log(assetNames[2], "assetnames");
  const [disabled2, setDisabled2] = useState(true);
  // const [disabled4, setDisabled4] = useState(false); //disable req btn, country, amount

  const createRequest = () => {
    if (sendDetails.amount != "" && sendDetails.country != "") {
      http
        .post(`/validationrequest?mobile=${data.mobile}`, sendDetails)
        .then((res) => {
          const id = res.data.Data;
          setDta({ ...data, id: id });
          if (res.data.statusCode === 0) {
            toast.success("Successfully Created Request");
            setDisabled2(false);
            setDisabled(true);

            http
              .get("/assetname")
              .then((res) => {
                if (oldArrar !== 0) {
                  setAssetNames(res.data.Data);
                  setallassetNames(res.data.Data);
                } else if (oldArrar) {
                }

                // setDisabled2(false);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (res.data.statusCode === 1) {
            toast.error("request not success");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toast.error("Please Enter the Amount and Country ");
    }
  };

  const formData = {
    mobile: data["mobile"],
    assettype: data["assettype"],
    ISINCode: data["isinnum"],
    country: data["country"],
    request: data["id"],
    amount: data["Amount"],
    stockname: data["assetname"],
    totaladvisedamnt: data["totaladvisedamnt"],
  };

  const addAdvice = () => {
    if (formData.totaladvisedamnt.length > 0) {
      if (
        parseInt(formData.amount, 10) <= parseInt(formData.totaladvisedamnt, 10)
      ) {
        http
          .post("manualadvice", formData)
          .then((res) => {
            setOldArray((oldArrar) => [...oldArrar, res.data]);
            setSumData((sumData) => [...sumData, res.data.amount]);
            setDta({ ...data, assetname: "", assettype: "", isinnum: "" });
            document.getElementById("assettype").value = "";
            document.getElementById("assetname").value = "";
            document.getElementById("Amount").value = "";
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        toast.error("Amount is more than Total Advised Amount");
      }
    } else {
      toast.error("Enter Total Advised Amount");
    }
    // if (oldArrar) {
    //   alert("in");
    // }
  };

  const autoCompleteClick = () => {
    var assetnames_notadded = [];
    if (oldArrar) {
      // console.log(assetNames, "Hello");
      // console.log(oldArrar, "oldArrar");
      assetNames.map((item, index1) => {
        var item_val = false;
        oldArrar.map((asset_added, index2) => {
          // console.log(oldArrar, "oldArrar-inside");
          if (item.ISINCode === asset_added.ISINCode) {
            item_val = true;
          }
        });
        if (!item_val) {
          assetnames_notadded.push(item);
          // console.log(assetnames_notadded, "New Array");
        }
        setAssetNames(assetnames_notadded);
        setDta({ ...data, assetname: "" });
      });
    }
  };

  const [cols, setCols] = useState([
    {
      headername: "ID",
      id: "id",
    },
    {
      headername: "Stock Name",
      id: "stockname",
      preview: true,
    },
    {
      headername: "Asset Type",
      id: "assettype",
      preview: true,
    },
    {
      headername: "Amount",
      id: "amount",
      format: "amount",
      preview: true,
    },
    {
      headername: "ISIN Code",
      id: "ISINCode",
      preview: true,
    },
    {
      headername: "Country",
      id: "country",
    },
    {
      headername: "Created",
      id: "created_draft",
      format: "date",
    },
    {
      headername: "Updated",
      id: "updated_draft",
      format: "date",
    },
    { id: "edit", headerName: "" },
    { id: "del", headerName: "" },
  ]);

  const [editCountryAmount, setEditCountryAmount] = useState(true);
  const [editingAmount, setEditingAmount] = useState("");
  const [isinNumbers, setIsinNumbers] = useState({});
  const [editModal, setEditModal] = useState(false);
  const [editAmount, setEditAmount] = useState("");
  const [deleteCountry, setDeleteCountry] = useState(false);
  const [editProposal, setEditProposal] = useState(false);
  const [deletingCountry, setDeletingCountry] = useState({});
  const [deletingCountryISIN, setDeletingCountryISIN] = useState({});
  const [disableeditAmountUpdateBtn, setdisableeditAmountUpdateBtn] =
    useState(true);
  // const [err, seterr]=useState(false);

  const editRow = (object) => {
    setEditCountryAmount(true);
    setEditingAmount(object.id);
    setIsinNumbers(object);
    setEditModal(true);
    setEditAmount(object);
  };

  const editAmountValidations = (event) => {
    let currentAmount = event.target.value;
    setEditAmount(currentAmount);
    setdisableeditAmountUpdateBtn(false);
  };

  const handleClose = () => {
    setDeleteCountry(false);
    setEditModal(false);
    setEditProposal(false);
    setdisableeditAmountUpdateBtn(true);
  };

  // const[amt, setamt]=useState("");
  // console.log(amt);

  const getData = () => {
    http
      .get("advicerequestsbyid/" + data.id + "/")
      .then((res) => {
        setOldArray(res.data.Data);
      })
      .catch((err) => {});
  };

  const editCountry = () => {
    if (parseInt(editAmount) >= parseInt(data["totaladvisedamnt"])) {
      toast("Amount should not be greater or equal than total advised amount");
    } else if (parseInt(editAmount) < parseInt(data["totaladvisedamnt"])) {
      http
        .patch("updatemanualrequest/" + editingAmount + "/", {
          amount: editAmount,
        })
        .then((res) => {
          toast.success("Updated SuccessFully");
          setEditModal(false);
          // editCountryAmount(editAmount);
          getData();
          setdisableeditAmountUpdateBtn(true);
        })
        .catch((error) => {
          console.log("Error found");
        });
    }
  };

  useEffect(() => {}, [editAmount]);

  const DeleteRow = (object) => {
    setDeleteCountry(true);
    setDeletingCountry(object.id);
    setDeletingCountryISIN(object.ISINCode);
  };

  const submitDelete = () => {
    let assetnameToadd = oldArrar.filter(
      (asset) => asset.ISINCode === deletingCountryISIN
    );
    const getfirstassetToAdd = assetnameToadd.find(
      (asset) => asset.ISINCode === deletingCountryISIN
    );
    // console.log(getfirstassetToAdd, "getfirstassetToAdd");
    let assetnameindex = oldArrar.indexOf(getfirstassetToAdd);
    // console.log(oldArrar, "Not deleted");
    let result = oldArrar.splice(assetnameindex, 1);

    const filteredArray = allAssetNames.filter(
      (item1) => !oldArrar.some((item2) => item1.ISINCode === item2.ISINCode)
    );

    setAssetNames(filteredArray);

    http
      .delete("updatemanualrequest/" + deletingCountry + "/")
      .then((res) => {
        toast.success("Deleted SuccessFully");
        setDeleteCountry(false);
        // getAdviceList();
        setDeletingCountry("");
        getData();
      })
      .catch((error) => {
        console.log("Error found");
      });
  };

  const sendProposal = (e) => {
    var sum = 0;

    if (data["totaladvisedamnt"] > invlimit) {
      toast.error(`${data["totaladvisedamnt"]} is beyond the ${invlimit}`);
    } else {
      // Running the for loop
      for (let i = 0; i < oldArrar.length; i++) {
        sum += oldArrar[i].amount;
      }
      if (parseInt(data["totaladvisedamnt"]) === sum) {
        // console.log("amount matched");
        setEditProposal(true);
      } else {
        toast.error(
          data["totaladvisedamnt"] +
            " " +
            "amount is not matched with" +
            " " +
            sum
        );
      }
    }
  };

  const sendToProposal = () => {
    http
      .get("invreq_by_id/" + data["id"] + "/")
      .then((res) => {
        setEditProposal(false);
        if (res.data.statusCode === 1) {
          toast.error(res.data.error);
        } else if (res.data.statusCode === 0) {
          toast.success("Advise sent successfully");
        }
        setTimeout(() => {
          gotoAdviceRequest();
        }, 2000);
      })
      .catch((err) => {
        console.log("Eroor found");
      });
  };

  const [setPreview, setShowPreview] = useState(false);
  const preview = () => {
    setShowPreview(true);
  };

  const [showPDFeditfields, setshowPDFeditfields] = useState(false);
  const PDFeditfields = () => {
    setshowPDFeditfields(true);
  };

  const closePrevent = () => {
    setShowPreview(false);
  };

  const handlePdfName = (e) => {
    setpdfName(e.target.value);
  };

  // Date for FileName

  // const currentDate = new Date();

  // const dateFormat = { day: "2-digit", month: "2-digit", year: "numeric" };
  // const formattedDate = currentDate
  //   .toLocaleDateString("en-GB", dateFormat)
  //   .replace(/\//g, "."); // /regex/g  g--> find all matches

  // Capitalize all intials of the name
  let investorname = pdfName
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return (
    <div>
      <div
        style={{
          display: "grid",
          gridAutoColumns: "1fr",
          gridAutoFlow: "column",
          alignItems: "center",
        }}
      >
        <div>
          <Button
            variant="outlined"
            color="default"
            startIcon={<ArrowBackIosIcon />}
            onClick={gotoAdviceRequest}
          >
            Back
          </Button>
        </div>
        <div style={{ fontSize: "35px", textAlign: "center" }}>
          <h5>Create Advise</h5>
        </div>
        <div></div> {/* Ignore this div */}
      </div>

      <div className="addadvicefields">
        <div className="addadvicefieldsleft">
          <p></p>
          <h2>
            Name of the customer:{" "}
            <span style={{ fontWeight: "normal" }}>{customerName}</span>
          </h2>
          {fieldData.map((item, index) => {
            return (
              <div className="addadvicefieldsleftrows">
                <label
                  style={{
                    display: "inline-block",
                    width: "30%",
                    marginRight: 0,
                  }}
                >
                  {item.label}{" "}
                  <span style={{ color: "red" }}>
                    {item.important === true ? "*" : " "}
                  </span>
                </label>
                {item.type === "text" && item.name === "Amount" ? (
                  <TextField
                    placeholder="Enter"
                    variant="outlined"
                    type="text"
                    name={item.name}
                    id={item.name}
                    onChange={handleChange}
                    disabled={disabled2}
                    style={{ width: "227px" }}
                  />
                ) : item.type === "text" && item.name === "totaladvisedamnt" ? (
                  <TextField
                    autoComplete="off"
                    placeholder="Enter"
                    variant="outlined"
                    type="text"
                    name={item.name}
                    id={item.name}
                    onChange={handleChange}
                    disabled={disabled}
                    style={{ width: "227px" }}
                  />
                ) : item.type === "text" && item.name === "assettype" ? (
                  <TextField
                    // placeholder="Enter"
                    variant="outlined"
                    type="text"
                    name={item.name}
                    value={data["assettype"]}
                    disabled={true}
                    id={item.name}
                    style={{ width: "227px" }}
                  />
                ) : item.type === "text" && item.name === "isinnum" ? (
                  <TextField
                    // placeholder="Enter"
                    variant="outlined"
                    type="text"
                    name={item.name}
                    value={data["isinnum"]}
                    disabled={true}
                    id={item.name}
                    style={{ width: "227px" }}
                  />
                ) : item.type === "text" && item.name === "mobile" ? (
                  <div>
                    <TextField
                      style={{ marginRight: 10, width: "227px" }}
                      placeholder="Enter"
                      variant="outlined"
                      name={item.name}
                      id={item.name}
                      type="text"
                      onChange={handleChange}
                      disabled={disabled3}
                    />{" "}
                    {item.name === "mobile" && Verifybtn === true ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={verifyNumber}
                        disabled={disabled3}
                      >
                        Verify
                      </Button>
                    ) : (
                      ""
                    )}
                    {item.name === "mobile" ? (
                      <>
                        {statuscode === 0 ? (
                          <p style={{ color: "green" }}>
                            Successfully Verified
                          </p>
                        ) : (
                          <p style={{ color: "blue" }}>Verify Mobile Number</p>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                ) : item.type === "select" ? (
                  <>
                    <TextField
                      variant="outlined"
                      select
                      size="small"
                      style={{
                        width: "227px",
                        marginRight: 15,
                      }}
                      placeholder="Select"
                      onChange={handleChange}
                      name={item.name}
                      disabled={disabled}
                      id={item.name}
                      value={data["country"]}
                    >
                      <MenuItem value="">Select</MenuItem>
                      {statuscode === 0
                        ? getCntryData.map((item, index) => {
                            return (
                              <MenuItem value={item.name}>{item.name}</MenuItem>
                            );
                          })
                        : ""}
                    </TextField>
                    {!data.id ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={createRequest}
                        // disabled={disabled4}
                      >
                        Create Request
                      </Button>
                    ) : (
                      ""
                    )}
                  </>
                ) : item.type === "autocomplete" ? (
                  <Autocomplete
                    disableClearable
                    style={{ width: "227px" }}
                    size="small"
                    id={item.name}
                    // options={assetNames !== 0 ? assetNames : []}

                    options={assetNames !== 0 ? assetNames : []}
                    getOptionLabel={(option) => option.Investment_Name}
                    renderOption={(option) => option.Investment_Name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Asset Name"
                        variant="outlined"
                        onClick={autoCompleteClick}
                      />
                    )}
                    onChange={(event, newValue) => {
                      handleChangeCompany(event, newValue);
                    }}
                    name={item.name}
                    disabled={disabled2}
                  />
                ) : (
                  ""
                )}
              </div>
            );
          })}
          <Button
            variant="contained"
            color="primary"
            style={{ marginLeft: 10, borderRadius: 60, textAlign: "right" }}
            startIcon={<AddCircleOutlineIcon />}
            className={"addBtn"}
            onClick={addAdvice}
          >
            Add to Advice List
          </Button>
        </div>
        <div className="addadvicefieldsright">
          <p>Nature: 50 Lakhs, xyz Feature, Other Features</p>
          {invlimit && <p>Investment Limit: {invlimit}</p>}
          <p></p>

          {oldArrar.length !== 0 ? (
            <Button
              variant="contained"
              color="primary"
              onClick={sendProposal}
              style={{ marginTop: "20px", cursor: "pointer" }}
            >
              Send Proposal
            </Button>
          ) : (
            <Button
              variant="contained"
              disabled
              style={{ marginTop: "20px", cursor: "pointer" }}
            >
              Send Proposal
            </Button>
          )}
        </div>
      </div>

      {oldArrar.length ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
              }}
            >
              <Button onClick={preview} variant="contained" color="primary">
                Preview
              </Button>
              <Button
                onClick={PDFeditfields}
                variant="contained"
                color="primary"
              >
                Edit PDF
              </Button>
              <Button variant="contained" color="primary">
                <PDFDownloadLink
                  document={
                    <InvestmentPlan
                      tabledata={oldArrar}
                      custname={investorname}
                      pdfitems={pdfcontent}
                      pdftextabovetable={convertedContentAboveTable}
                      pdftextbelowtable={convertedContentBelowTable}
                    />
                  }
                  fileName={
                    "Investment Plan - " +
                    investorname +
                    " " +
                    formattedDate +
                    ".pdf"
                  }
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  {({ blob, url, loading, error }) =>
                    loading ? "Loading" : "Generate Plan"
                  }
                  Generate Plan
                </PDFDownloadLink>
              </Button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {/* {oldArrar.length ? (
        <>
          <p style={{ display: "flex", alignItems: "center" }}>
            {" "}
            <b style={{ marginRight: 5 }}>Client Name for PDF:</b>
            <TextField
              variant="outlined"
              onChange={(e) => setpdfName(e.target.value)}
              value={pdfName}
            />
          </p>
        </>
      ) : (
        " "
      )} */}

      {oldArrar.length ? (
        <TableContainer style={{ marginBottom: "15px" }}>
          <Table>
            <TableHead>
              <TableRow>
                {cols.map((col, index) => {
                  return (
                    <TableCell>
                      <TableSortLabel>{col.headername}</TableSortLabel>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {oldArrar.map((item, index) => {
                return (
                  <TableRow>
                    {cols.map((col, index) => {
                      const value = item[col.id];
                      return (
                        <TableCell>
                          {col.format === "date" ? (
                            getDate(value)
                          ) : col.format === "amount" ? (
                            value
                          ) : col.id === "edit" ? (
                            <Button
                              style={{
                                borderRadius: 10,
                                marginLeft: 10,
                                textTransform: "math-auto",
                              }}
                              onClick={() => editRow(item)}
                              variant="contained"
                              color="primary"
                            >
                              Edit
                            </Button>
                          ) : col.id === "del" ? (
                            <Button
                              onClick={() => DeleteRow(item)}
                              variant="contained"
                              color="primary"
                            >
                              Delete
                            </Button>
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        ""
      )}

      <Dialog
        open={editModal}
        onClose={handleClose}
        //   PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Editing
        </DialogTitle>
        <DialogContent>
          <TextField
            variant="outlined"
            value={isinNumbers.ISINCode}
            disabled
            label="ISINCode"
          />
          {/* Are you sure to Delete Role {currentUser.role}? */}
          <TextField
            InputLabelProps={{ shrink: true }}
            size="small"
            variant="outlined"
            value={editAmount.amount}
            label="Amount"
            onChange={(e) => editAmountValidations(e)}
            style={{
              marginLeft: "25px",
              width: "300px",
            }}
            // onChange={(e) => setEditAmount(e.target.value)}
          />
          {/* {
                        err ?<p style={{ color: 'red' }}>
                            Please enter valid amount                            
                        </p> : ""       
                    } */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            Cancel
          </Button>
          <Button
            autoFocus
            onClick={(e) => editCountry(e)}
            variant="contained"
            color="primary"
            disabled={disableeditAmountUpdateBtn}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteCountry}
        onClose={handleClose}
        //   PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Do you really want to delete?
        </DialogTitle>
        <DialogContent>
          {/* Are you sure to Delete Role {currentUser.role}? */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            No
          </Button>
          <Button
            autoFocus
            onClick={submitDelete}
            variant="contained"
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={editProposal}
        onClose={handleClose}
        //   PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Do you really want to approve the Advise?
        </DialogTitle>
        <DialogContent>
          {/* Are you sure to Delete Role {currentUser.role}? */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            No
          </Button>
          <Button
            autoFocus
            onClick={sendToProposal}
            variant="contained"
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {setPreview ? (
        <Dialog open={setPreview} className="dialouge_adaadvice">
          <p
            style={{ textAlign: "right", paddingRight: 10, cursor: "pointer" }}
          >
            <CancelOutlined onClick={closePrevent} />
          </p>
          <div>
            <DataSheetGrid value={oldArrar} columns={columns} />
          </div>
        </Dialog>
      ) : (
        ""
      )}

      {showPDFeditfields ? (
        <Dialog
          open={showPDFeditfields}
          className="dialouge_adaadvice"
          fullWidth
          maxWidth="lg"
          minHeight="500px"
        >
          <DialogContent>
            <p
              style={{
                textAlign: "right",
                paddingRight: 10,
                cursor: "pointer",
              }}
            >
              <CancelOutlined onClick={() => setshowPDFeditfields(false)} />
            </p>
            <div>
              <div>
                <p style={{ display: "flex", alignItems: "center" }}>
                  {" "}
                  <b style={{ marginRight: 5, width: "175px" }}>
                    Client Name for PDF:
                  </b>
                  <TextField
                    variant="outlined"
                    onChange={(e) => setpdfName(e.target.value)}
                    value={pdfName}
                  />
                </p>
                <p style={{ display: "flex", alignItems: "center" }}>
                  {" "}
                  <b style={{ marginRight: 5, width: "200px" }}>
                    Add text above the table:
                  </b>
                  <div style={{ width: "100%" }}>
                    <Editor
                      defaultContentState={contentState}
                      // editorState={editorState}
                      onEditorStateChange={seteditorAbovetable}
                      wrapperClassName="wrapper-class"
                      editorClassName="editor-class"
                      toolbarClassName="toolbar-class"
                      // toolbarHidden={true}
                      toolbar={{
                        options: ["inline"],
                        inline: {
                          options: ["bold"],
                        },
                      }}
                    />
                  </div>
                </p>

                <p style={{ display: "flex", alignItems: "center" }}>
                  {" "}
                  <b style={{ marginRight: 5, width: "200px" }}>
                    Add text below the table:
                  </b>
                  <div style={{ width: "100%" }}>
                    <Editor
                      defaultContentState={contentState}
                      // editorState={editorState}
                      onEditorStateChange={seteditorBelowtable}
                      wrapperClassName="wrapper-class"
                      editorClassName="editor-class"
                      toolbarClassName="toolbar-class"
                      // toolbarHidden={true}
                      toolbar={{
                        options: ["inline"],
                        inline: {
                          options: ["bold"],
                        },
                      }}
                    />
                  </div>
                </p>
                {/* <div>{convertedContentAboveTable}</div> */}
                {/* <div>{convertedContentBelowTable}</div> */}
              </div>
            </div>
          </DialogContent>
        </Dialog>
      ) : (
        ""
      )}
    </div>
  );
}

export default Addadvice;
